import { useMutation } from 'react-query'
import { useParams } from 'react-router-dom'
import { paymentsService } from 'src/services/payments.service'

const useCreatePortalSession = () => {
  const { accountId } = useParams()
  return useMutation(() => paymentsService.createPortalSession({ accountId: accountId! }))
}

export { useCreatePortalSession }
